<alert [nom]="NOM_ALERTE_PLANNING" class="alerte" nomBouton="GLOBAL.OUI"></alert>

<div class="planning">
	<div class="filtres">
		<span class="titre-filtre">{{ 'PLANNING.FILTRES.TITRE_FILTRE' | translate }}</span>
		<p-scrollPanel styleClass="scroll-panel-filtres">
			<div class="filtre-multi-select">
				<span class="label-filtre-multi-select">{{ 'PLANNING.FILTRES.LABEL_EQUIPES_GROUPES_DE_TRAVAIL' | translate }}</span>
				<div class="filtre-equipe-groupe-de-travail">
					<p-multiSelect
							style="width: 100%"
							[group]="true"
							[options]="equipesEtGroupesDeTravailItemsGroup()"
							[(ngModel)]="equipesGroupesDeTravailSelectionnes"
							selectedItemsLabel="{{ 'GLOBAL.FILTRES.NB_ELEMENTS_SELECTIONNES' | translate }}"
							[placeholder]="'PLANNING.FILTRES.PLACEHOLDER_FILTRE_GROUPES_DE_TRAVAIL' | translate"
							[emptyMessage]="'PLANNING.FILTRES.AUCUN_GROUPE_DE_TRAVAIL' | translate">
						<ng-template let-titreSection pTemplate="group">
							<span>{{ titreSection.label }}</span>
						</ng-template>
					</p-multiSelect>
					<p-button type="button"
							  label="{{ 'GESTIONS_ZONES_AUTORISEES.BTN_AJOUTER' | translate }}"
							  (onClick)="onClickAjouterEquipesEtGroupesDeTravailSelectionnes()"/>
				</div>
				<div class="chip-scroll-panel">
					<p-scrollPanel [style]="{ height: '125px' }">
						<div class="chip-equipes-groupes-de-travail">
							@for (equipe of equipesSelectionnes(); track equipe) {
								<p-chip
										icon="pi pi-users"
										pTooltip="{{ 'GLOBAL.EQUIPE' | translate }}"
										[label]="equipe.nom"
										[removable]="true"
										(onRemove)="onRemoveFiltreEquipe(equipe)"/>
							}
							@for (groupeDeTravail of groupesDeTravailSelectionnes(); track groupeDeTravail) {
								<p-chip
										icon="pi pi-comments"
										pTooltip="{{ 'GLOBAL.GROUPE_DE_TRAVAIL' | translate }}"
										[label]="groupeDeTravail.nom"
										[removable]="true"
										(onRemove)="onRemoveFiltreGroupeDeTravail(groupeDeTravail)"/>
							}
						</div>
					</p-scrollPanel>
				</div>
			</div>
			<div class="filtre-multi-select">
				<span class="label-filtre-multi-select">{{ 'PLANNING.FILTRES.LABEL_UTILISATEURS' | translate }}</span>
				<p-multiSelect
						[group]="false"
						[options]="utilisateursOptions()"
						optionLabel="prenomNom"
						[(ngModel)]="utilisateursSelectionnes"
						display="chip"
						selectedItemsLabel="{{ 'GLOBAL.FILTRES.NB_ELEMENTS_SELECTIONNES' | translate }}"
						[placeholder]="'PLANNING.FILTRES.PLACEHOLDER_FILTRE_UTILISATEURS' | translate"
						[emptyMessage]="'PLANNING.FILTRES.AUCUN_UTILISATEUR' | translate">
				</p-multiSelect>
			</div>

			<!-- Filtres administrateurs -->
			@if (estAdministrateur()) {
				<p-divider/>
				<span class="titre-filtres-admin">{{ 'PLANNING.FILTRES.TITRE_FILTRE_ADMIN' | translate }}</span>
				<div class="filtre-multi-select">
					<span class="label-filtre-multi-select">{{ 'PLANNING.FILTRES.LABEL_AUTOCOMPLETE_UTILISATEUR' | translate }}</span>
					<div class="autocomplete-ajout-utilisateur">
						<p-autoComplete
								id="utilisateur-autocomplete"
								[style]="{'width':'100%'}"
								[inputStyle]="{'width':'100%'}"
								[(ngModel)]="utilisateurAAjouter"
								[forceSelection]="true"
								[showClear]="true"
								[suggestions]="utilisateursSuggestions()"
								(completeMethod)="rechercherUtilisateurs($event)"
								[optionLabel]="recupererPrenomNomSuggestionAutomcomplete"
								emptyMessage="{{ 'PLANNING.FILTRES.AUTOCOMPLETE_UTILISATEUR_VIDE' | translate }}">
						</p-autoComplete>
						<div class="button-ajouter-utilisateur">
							<p-button
									(onClick)="ajouterUtilisateurAutoCompleteAdministrateur()"
									label="{{ 'GLOBAL.BTN_AJOUTER' | translate }}"
									[disabled]="isButtonAjouterUtilisateurDisabled()"
									[loading]="loadingAjouterUtilisateur()"></p-button>
						</div>
					</div>
					<div class="chip-scroll-panel">
						<p-scrollPanel [style]="{ height: '125px' }">
							<div class="chip-equipes-groupes-de-travail">
								@for (utilisateur of utilisateursSelectionnesAutocompleteAdmin(); track utilisateur) {
									<p-chip
											icon="pi pi-user"
											[label]="utilisateur.prenom + ' ' + utilisateur.nom"
											[removable]="true"
											(onRemove)="onRemoveFiltreUtilisateur(utilisateur)"/>
								}
							</div>
						</p-scrollPanel>
					</div>
				</div>
			}
		</p-scrollPanel>
	</div>
	<div class="calendrier">
		<app-calendrier-header
				[dateActuelleCalendrier]="dateActuelle()"
				[typeChangementDate]="TypeChangementDate.SEMAINE"
				(eventChangerDeDate)="changerDeSemaine($event)"/>
		<p-scrollPanel [style]="{ width: '100%' }">
			@if (loading()) {
				<div class="spinner">
					<div class="app-spinner"></div>
				</div>
			} @else {
				<div class="calendrier-content"
					 [style.grid-template-columns]="afficherWeekend() ? 'repeat(7, 1fr)' : 'repeat(5, 1fr)'">
					@if (isNotNullOrUndefined(semaine())) {
						@for (jour of semaine().jours; track jour) {
							<div class="jour-container">
								<div class="date-jour {{ classeJourCourant(jour) }}">
									<div>{{ recupererJourSemaine(jour) }}</div>
								</div>
								<div class="evenements-jour">
									<!-- Affichage des événements de type BUREAU par ilot -->
									@if (estJourneePossedeTypeEvenementPlanning(jour, TypeEvenement.BUREAU)) {
										@for (site of recupererSitesReservees(jour); track site) {
											<app-evenement-planning
													[evenementsPlannings]="recupererEvenementPlanningPourDateEtTypeEvenement(jour, TypeEvenement.BUREAU, site)"
													[typeEvenement]="TypeEvenement.BUREAU"
													[site]="site"/>
										}
									}

									<!-- Affichage des autres événements -->
									@for (typeEvenement of recupererTypesEvenements(); track typeEvenement) {
										@if (TypeEvenement.BUREAU !== typeEvenement) {
											@if (estJourneePossedeTypeEvenementPlanning(jour, typeEvenement)) {
												<app-evenement-planning
														[evenementsPlannings]="recupererEvenementPlanningPourDateEtTypeEvenement(jour, typeEvenement)"
														[typeEvenement]="typeEvenement"/>
											}
										}
									}
								</div>
								<!-- Le panel ne descend pas jusqu'en bas donc on rajoute la div pour avoir un affichage correct -->
								<div class="evenement-vide"></div>
							</div>
						}
					}
				</div>
			}
		</p-scrollPanel>
	</div>
</div>
